<!--
 * @Description: 头部
 * @Date: 2020-07-15 17:57:24
-->

<template>
  <div class="bi-header">
    <div class="bi-header-content">
      <p class="bi-header-content-top">
        {{ obj.projectName }}
        <br />
        {{ obj.taskDt }}服务报告
      </p>
      <div class="bi-header-content-b">
        <div class="bi-header-content-b-m">
          <p>
            <span>项目名称：</span>
            <span>{{ obj.projectName }}</span>
          </p>
          <div>
            <p>
              <span>发起方：</span>
              <span>{{ obj.industryId == -1 ? '-' : obj.industryName }}</span>
            </p>
            <p>
              <span>服务商：</span>
              <span>{{ obj.csoName }}</span>
            </p>
            <p>
              <span>提交日期：</span>
              <span>{{ obj.commitTime }}</span>
            </p>
            <p>
              <span>任务数量：</span>
              <span>{{ obj.taskSum }}</span>
            </p>
            <p>
              <span>项目执行人数：</span>
              <span>{{ obj.userCount }}人</span>
            </p>
            <p>
              <span>报表生成时间：</span>
              <span>{{ `${obj.now}`.split(' ')[0] }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    obj: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return { resp: {} };
  },
  components: {},
  watch: {},
  computed: {},
  methods: {},
  async created() {},
  beforeDestroy() {}
};
</script>

<style scoped lang="scss">
@import '~@/styles/mixin.scss';
.box {
  max-width: 1200px;
}
.bi-header {
  &-content {
    @extend .box;
    text-align: left;
    padding-top: 75px;
    &-top {
      font-size: 26px;
      color: #333333;
      line-height: 48px;
      margin-bottom: 40px;
      // padding-top: 80px;
      text-align: center;
    }

    &-b {
      border: 4px solid #313131;
      padding: 11px;
      &-m {
        width: 100%;
        height: 100%;
        padding: 35px 40px 40px 48px;
        border: 2px solid #313131;
        display: flex;
        flex-wrap: wrap;
        & > p {
          width: 100%;
        }
        & > div {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          p {
            margin-top: 30px;
            width: 33.333%;
            display: flex;
            &:nth-child(3n + 3) {
              width: 210px;
            }
            & > span:first-child {
              flex-shrink: 0;
            }
          }
        }
      }
      div {
        // width: 30%;
        p {
          text-align: left;
          &:last-child {
            margin-bottom: 0;
          }
        }
        span {
          font-size: 14px;
          color: #333;
          letter-spacing: 1px;
          &:last-child {
            font-weight: bold;
          }
        }
      }
      &-right {
        p {
          text-align: right !important;
        }
      }
    }
  }
}
</style>
